<template>
<div class="chapter">
<div class="inner_page">
<p class="space4">
</p><p class="paracenter1"><a id="page_2"></a><a id="dedication"><span class="bold">Dedication</span><br/> <em class="italic">To Lt Ralph Eugene Foulks Jr US Navy<br/>Lost over Vietnam 5 January 1968</em></a></p><a id="dedication">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?55051562